// extracted by mini-css-extract-plugin
module.exports = {"tableRow":"style_tableRow__cMOs4","table":"style_table__1StYb"};